import React from 'react';
import s from './SignalTranslation.module.scss';
import { FormattedMessage } from 'react-intl';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch';
import InputNumber from '../WSAControls/InputNumber/InputNumber';

const SignalTranslationConstants = ({ signalTranslationManager, setSignalTranslationRequired, setSignalTranslationConstant, isViewMode, UpdateAllowed, intl }) => {
  const selectedSignalTranslation = signalTranslationManager.SelectedSignalTranslation;
  const labelZoomUnchecked = <FormattedMessage id="signalTranslation.signalTranslationRequired.no" defaultMessage="No" />;
  const labelZoomChecked = <FormattedMessage id="signalTranslation.signalTranslationRequired.yes" defaultMessage="Yes" />;
  const signalTranslationReqHandler = () => {
    setSignalTranslationRequired();
  };

  const saveCompConstHandler = signalTranslationComponentConstants => {
    let listData = selectedSignalTranslation.SignalTranslationComponentConstants;

    if (signalTranslationComponentConstants.SignalTranslationComponentConstantId > 0) {
      const updatedData = listData.map(x =>
        x.SignalTranslationComponentConstantId === signalTranslationComponentConstants.SignalTranslationComponentConstantId
          ? { ...x, ...signalTranslationComponentConstants }
          : x
      );
      setSignalTranslationConstant({
        SignalTranslationComponentConstants: updatedData
      });
    } else {
      let hasItem = listData.filter(item => {
        if (item.SignalTranslationEquationConstantId === signalTranslationComponentConstants.SignalTranslationEquationConstantId) return item;
      });

      if (hasItem.length > 0) {
        const updatedData = listData.map(x =>
          x.SignalTranslationEquationConstantId === signalTranslationComponentConstants.SignalTranslationEquationConstantId
            ? { ...x, ...signalTranslationComponentConstants }
            : x
        );
        setSignalTranslationConstant({
          SignalTranslationComponentConstants: updatedData
        });
      } else {
        listData.push(signalTranslationComponentConstants);
        setSignalTranslationConstant({
          SignalTranslationComponentConstants: listData
        });
      }
    }
  };

  return (
    <div className={s.signalTranslation}>
      <div className={s.contentWrapper}>
        <div className={s.signalTranslationConstants}>
          <Row className={s.standardRow}>
            <Col sm={6} lg={8}>
              <h4 className={s.subheading}>
                <FormattedMessage id="signalTranslation.signalTranslationConstants" defaultMessage="SignalTranslation Constants" />
              </h4>
            </Col>
            <Col sm={6} lg={4}></Col>
          </Row>
          <Row className={s.standardRow}>
            <Col md={2}>
              <Form.Label>
                <FormattedMessage id="signalTranslation.signalTranslationEquation" defaultMessage="SignalTranslation equation" />
              </Form.Label>
            </Col>
            <Col md={10}>
              <span className={s.padleft}>{selectedSignalTranslation.SignalTranslationEquationName}</span>
            </Col>
          </Row>
          <Row className={s.standardRow}>
            <Col md={2}>
              <Form.Label>
                <FormattedMessage id="signalTranslation.signalTranslationFormula" defaultMessage="SignalTranslation formula" />
              </Form.Label>
            </Col>
            <Col md={10}>
              <span className={s.padleft}>{selectedSignalTranslation.SignalTranslationEquationFormula}</span>
            </Col>
          </Row>
          <Row className={s.standardRow}>
            <Col md={2}>
              <Form.Label>
                <FormattedMessage id="signalTranslation.signalTranslationRequired" defaultMessage="SignalTranslation required" />
              </Form.Label>
            </Col>
            <Col md={10}>
              {!isViewMode && (
                <ToggleSwitch
                  handleClick={signalTranslationReqHandler}
                  classname={s.switch}
                  checked={selectedSignalTranslation.SignalTranslationRequired}
                  labelChecked={labelZoomChecked}
                  labelUnchecked={labelZoomUnchecked}
                />
              )}
              <span className={s.padleft}>
                {isViewMode && (selectedSignalTranslation.SignalTranslationRequired ? labelZoomChecked : labelZoomUnchecked)}
              </span>
            </Col>
          </Row>
           <Row>
            <Col className={s.tabContainer}>
              <Table variant className={`${s.wsInnerTable}`}>
                <thead>
                  <tr>
                    <th>
                      <FormattedMessage id="signalTranslation.signalTranslationConstantsName" defaultMessage="Name" />
                    </th>
                    <th>
                      <FormattedMessage id="signalTranslation.signalTranslationConstantsDescription" defaultMessage="Description" />
                    </th>
                    <th>
                      <FormattedMessage id="signalTranslation.signalTranslationConstantsValue" defaultMessage="Value" />
                    </th>
                    <th className={s.emptyCol}></th>
                  </tr>
                </thead>
                <tbody>
                  {selectedSignalTranslation.SignalTranslationComponentConstants.map(compConst => {
                    if (!isViewMode) {
                      return (
                        <ComponentConstantsRow
                          key={compConst.GuidIdentifier}
                          compConstant={compConst}
                          saveCompConstants={saveCompConstHandler}
                        />
                      );
                    } else {
                      return <ComponentConstantsRowView key={compConst.GuidIdentifier} compConstant={compConst} />;
                    }
                  })}
                </tbody>
              </Table>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default SignalTranslationConstants;

const ComponentConstantsRow = ({ compConstant, saveCompConstants }) => {
  const onChange = e => {
    const numericValue = Number(e.target.value);
    saveCompConstants({ ...compConstant, [e.target.name]: numericValue, isChanged: true });
  };

  return (
    <tr>
      <td>
        <div>{compConstant.Name}</div>
      </td>
      <td>
        <div>{compConstant.Description}</div>
      </td>
      <td>
        <InputNumber
          name="ConstantValue"
          step=".1"
          onInputChange={onChange}
          customClassName={s.textInput}
          value={compConstant.ConstantValue}
          id="formConstValue"
        />
      </td>

      <td className={s.emptyCol}></td>
    </tr>
  );
};

const ComponentConstantsRowView = ({ compConstant }) => {
  return (
    <tr>
      <td>
        <div>{compConstant.Name}</div>
      </td>
      <td>
        <div>{compConstant.Description}</div>
      </td>
      <td>
        <div>{compConstant.ConstantValue}</div>
      </td>

      <td className={s.emptyCol}></td>
    </tr>
  );
};
